module.exports = __webpack_public_path__ + "img/qudk.4159be5c.png";